import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M9.91007 17.4959L3.70711 11.2929C3.31658 10.9024 2.68342 10.9024 2.29289 11.2929C1.90237 11.6834 1.90237 12.3166 2.29289 12.7071L9.29289 19.7071C9.71682 20.131 10.4159 20.0892 10.7863 19.6178L21.7863 5.61782C22.1275 5.18355 22.0521 4.55489 21.6178 4.21368C21.1835 3.87247 20.5549 3.9479 20.2137 4.38218L9.91007 17.4959Z" />,
  'Check'
);
